module.exports = __webpack_public_path__ + "static/media/mold.3f0a4f9b.png";